<template>
  <MongoDataTable
    ref="table"
    :headers="new Array(7).fill({})"
    itemKey="key"
    :dataTableProps="{ expand: true }"
    :insertable="false"
    :editable="false"
    :deletable="false"
    :selectable="false"
    :refreshable="false"
    :filterable="false"
    :columnSelectable="false"
    :sortable="false"
    :rowsPerPage="-1"
    :countable="false"
    containerClass="elevation-0"
    :hideToolbar="true"
    :hideHeaders="false"
    :hideFooters="true"
    :onTableItems="v => v"
    :onRefresh="() => {}"
  >
    <!-- <template slot="title" style="display: none">
      <v-fade-transition>
        <v-icon
          v-html="'mdi-checkbox-blank-circle'"
          :color="getStatusColor(tableStatus)"
          class="mr-3"
        />
      </v-fade-transition>
      <span v-if="title" class="title d-inline-block my-2">
        {{ titleText(title) }}
      </span>
      <v-fade-transition>
        <sub v-if="tableErrorsCount > 0" class="caption mx-2 my-3 grey--text">
          <i>({{ tableErrorsCount }} Item Errors)</i>
        </sub>
      </v-fade-transition>
    </template> -->
    <template slot="headers" slot-scope="props">
      <tr>
        <th class="column text-xs-center" width="100">
          <div>Status</div>
        </th>
        <th class="column text-xs-center" width="100">
          <div>Client</div>
        </th>
        <th class="column text-xs-left" width="100">
          <div>Errors</div>
        </th>
        <th class="column text-xs-left" width="100">
          <div>Low Balances</div>
        </th>
        <th class="column text-xs-right">
          <div>Available USD</div>
        </th>
        <th class="column text-xs-right" width="130">
          <div>Balance USD</div>
        </th>
        <th width="30"></th>
      </tr>
    </template>
    <template slot="items" slot-scope="props">
      <tr class="disable-hover-color cursor-pointer" @click="props.scope.expanded = !props.scope.expanded">
        <td class="text-xs-center">
          <div class="">
            <v-icon
              v-html="'mdi-checkbox-blank-circle'"
              small
              :color="getStatusColor(props.scope.item.success)"
              class="mr-2"
            />
          </div>
        </td>
        <td class="text-xs-center">
          <span>{{ props.scope.item.key }}</span>
        </td>
        <td>
          <div class="d-flex align-center">
            <span v-if="props.scope.item.errors.length" class="grey--text">
              <i>{{ props.scope.item.errors.length }} Items</i>
            </span>
          </div>
        </td>
        <td>
          <div class="d-flex align-center">
            <span v-if="props.scope.item.incorrects.length" class="grey--text">
              <i>{{ props.scope.item.incorrects.length }} Items</i>
            </span>
          </div>
        </td>
        <td>
          <div class="text-xs-right">
            <span>{{ showCurrency(props.scope.item.summary.available_USD) }}</span>
          </div>
        </td>
        <td>
          <div class="text-xs-right">
            <span :class="[
              props.scope.item.incorrects.length ? 'red--text' : undefined
            ]">{{ showCurrency(props.scope.item.summary.balance_USD) }}</span>
          </div>
        </td>
        <td>
          <div class="d-flex align-center">
            <v-icon style="justify-content: flex-end;">
              {{ props.scope.expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
            </v-icon>
          </div>
        </td>
      </tr>
    </template>
    <template slot="expand" slot-scope="props">
      <div class="pa-4 grey lighten-5">
        <CurrencyBalance :items="props.item.value" />
      </div>
    </template>
    <template slot="tableFooter" v-if="ready">
      <tr>
        <th class="column text-xs-center">
          <span class="">Totals</span>
        </th>
        <td colspan="3"></td>
        <td class="column text-xs-right px-4">
          <span>{{ showCurrency(totalAvailableUSD) }}</span>
        </td>
        <td class="column text-xs-right px-4">
          <span>{{ showCurrency(totalBalanceUSD) }}</span>
        </td>
        <td></td>
      </tr>
    </template>
  </MongoDataTable>
</template>

<script>
import MongoDataTable from '../../components/mongo-datatable/MongoDataTable'
import MongoDataTableItemField from '../../components/mongo-datatable/MongoDataTableItemField'
import CurrencyBalance from '../../components/CurrencyBalance'
import { titleText } from '../../libs/utils'

export default {
  props: {
    ready: { type: Boolean, required: false, default: true },
    loading: { type: Boolean, required: false, default: false },
    title: { type: String, required: false, default: null },
    items: { type: Array, required: true }
  },
  computed: {
    tableStatus () {
      if (!this.ready) return null
      return this.items.every(secondGroup => {
        return !secondGroup.errors.length
      }) && this.items.every(secondGroup => {
        return !secondGroup.incorrects.length
      })
    },
    tableErrorsCount () {
      return this.items.reduce((c, secondGroup) => c + secondGroup.errors.length, 0)
    },
    totalAvailableUSD () {
      return this.items.reduce((c, secondGroup) => c + secondGroup.summary.available_USD, 0)
    },
    totalBalanceUSD () {
      return this.items.reduce((c, secondGroup) => c + secondGroup.summary.balance_USD, 0)
    }
  },
  watch: {
    loading: {
      immediate: true,
      handler (val) {
        this.$nextTick(async () => {
          await this.refresh()
        })
      }
    },
    items: {
      deep: true,
      handler (val) {
        this.$nextTick(async () => {
          await this.refresh()
        })
      }
    }
  },
  methods: {
    titleText,
    getStatusColor (value) {
      if (value === null) return null
      const color = value ? 'success' : 'error'
      this.$emit('statusChanged', color)
      return color
    },
    async refresh () {
      const table = this.$refs.table
      table.setLoader(this.loading)
      if (!this.loading) {
        table.setItems(this.items, true)
      }
    },
    showCurrency (value, symbol = '$') {
      return `${symbol} ${(+value).toFixed(2)}`
    }
  },
  components: {
    MongoDataTable,
    MongoDataTableItemField,
    CurrencyBalance
  }
}
</script>
